import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import $ from "jquery";
import React, { Component } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
const uuidv4 = require('uuid/v4')

import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from "moment";

const messages = defineMessages({
    "event_start_label": {
        id: 'calendar.event_details.start_label',
        defaultMessage: 'Start',
    },
    "event_end_label": {
        id: 'calendar.event_details.end_label',
        defaultMessage: 'End',
    },
    "event_participant_label": {
        id: 'calendar.event_details.participant_label',
        defaultMessage: 'Participant',
    },
})
let calendar = null
class FullCalendar extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            currentEvents: [],
            primaryColor: '#0275d8',
            secondaryColor: 'purple',
            backgroundColor: '#0275d8'
        }

        const defaultCallback = () => { }
        this.onTimeSelect = this.props.onTimeSelect || defaultCallback
    }

    componentDidMount() {
        this.initializeCalendar()
        if (this.props.calendarId) {
            calendar.render()
        }

        $('#' + this.state.modalId).modal('show')
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.startAt.getTime() !== prevProps.startAt.getTime() || this.props.endAt.getTime() !== prevProps.endAt.getTime()) {
            calendar.select(this.props.startAt, this.props.endAt)
        }
        if (this.props.calendarId && this.props.calendarId !== prevProps.calendarId) {
            calendar.render()
            calendar.refetchEvents()
        }
    }

    initializeCalendar() {
        let calendarEl = document.getElementById('calendar')
        let that = this
        calendar = new Calendar(calendarEl, {
            plugins: [timeGridPlugin, interactionPlugin],
            initialView: 'timeGridWeek',
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
            },
            height: 650,
            selectable: true,
            select: function (info) {
                $(".fc-highlight").css("background", that.state.backgroundColor)
                $(".fc-highlight").css("border", "2px solid black")
                that.onTimeSelect(info.start, info.end)
            },
            events: function (info, successCallback, failureCallback) {
                if (that.props.calendarId) {
                    AppContext.getApiClient().get(
                        `/calendars/${that.props.calendarId}/external-events?start=${info.start.valueOf() / 1000}&end=${info.end.valueOf() / 1000}`)
                        .then(res => {
                            if (res.error) {
                                failureCallback(res.error)
                                return
                            } else {
                                that.setState({
                                    currentEvents: res.data,
                                }, () => {
                                    successCallback(
                                        res.data.filter(event => event.status === 'confirmed').map(event => {
                                            return {
                                                title: event.title,
                                                start: event.when.start_time,
                                                end: event.when.end_time,
                                                id: event.id,
                                            }
                                        })
                                    )
                                    return
                                })
                            }
                        })
                }
            },
            eventColor: that.state.primaryColor,
            eventDidMount: function (info) {
                let event = that.state.currentEvents.find(e => e.id === info.event.id)
                if (event) {
                    if (event.id === that.props.externalCalendarEventId) {
                        info.el.style.backgroundColor = that.state.secondaryColor
                    }
                    let participant = ''
                    if (event.participants && event.participants.length > 0) {
                        participant = `${event.participants[0].name} (${event.participants[0].email})`
                    }
                    $(info.el).popover({
                        title: info.event.title,
                        trigger: 'hover',
                        html: true,
                        content: `${event.location} <br /> 
                        ${that.props.intl.formatMessage(messages["event_start_label"])}: ${moment(event.when.start_time).format('dddd, LL LT')} <br /> 
                        ${that.props.intl.formatMessage(messages["event_end_label"])}: ${moment(event.when.end_time).format('dddd, LL LT')}
                        ${that.props.intl.formatMessage(messages["event_participant_label"])}: ${participant} <br />
                        `,
                        container: 'body'
                    })
                }
            },
            nowIndicator: true,
            scrollTime: '08:00:00',
            allDaySlot: false,
        })
    }

    render() {
        return <div id="calendar" className={this.props.className} />
    }
}

export default injectIntl(FullCalendar)



// WEBPACK FOOTER //
// ./src/calendar/fullcalendar.component.jsx